module.exports = __webpack_public_path__ + "static/teamWork-1296362f5a873ed21c4fa54a1ce98863.png";